export * from './config';
export * from './glossary';
export * from './types';

import { en } from './resources/en';
import { ru } from './resources/ru';
import { zhHans } from './resources/zh-Hans';

export const translationResources = { en, ru, 'zh-Hans': zhHans } as const;
